import { render, staticRenderFns } from "./subproject-more.vue?vue&type=template&id=2471d9b4"
import script from "./subproject-more.vue?vue&type=script&lang=js"
export * from "./subproject-more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports